import React, { useRef } from "react";
import cn from "classnames";

import A11yElement from "components/helpers/A11yElement";
import { ReactComponent as CloseIcon } from "static/images/close.svg";

const GenericModal = ({ children, className, closeModal, title }) => {
  const container = useRef();
  const closeButton = useRef();

  return (
    <div ref={container} className={cn("otrl-jp__generic-modal", className)}>
      <div className="otrl-jp__generic-modal__header">
        <div className="otrl-jp__generic-modal__header__bar" onClick={closeModal}>
          <div className="otrl-jp__generic-modal__header__title-wrapper">
            <h1 className="otrl-jp__generic-modal__header__title">{title}</h1>
          </div>
          <A11yElement
            ref={closeButton}
            role="button"
            className="otrl-jp__generic-modal__close"
            onAction={closeModal}
          >
            <CloseIcon />
          </A11yElement>
        </div>
      </div>
      <div className="otrl-jp__generic-modal__wrapper">{children}</div>
    </div>
  );
};

export default GenericModal;
